import {API_URL,Accept} from '../constants.js';
import {notify} from 'react-notify-toast';
import api from "./api.js";
export default function holdreasonApi(trip_id,reason,component){
const Authorization='bearer '+localStorage.getItem('token');
  fetch(`${API_URL}rest/V1/rider/tripHold`,{
    method:'POST',
    headers:{"Content-Type": "application/json",Accept,Authorization},
      body:JSON.stringify({
        data: {
          jobId: trip_id,
          reason: reason
        } 
       
      })
        }).then(function(response){
          if(!response.ok){
              notify.show('Network Failure','error');
          }
          window.location.reload();
            return response.json();
        })
        .then(function(data) {
          console.log("checkholddata",data);
            // api.callShippingJobs(component,trip_id);
    })
}



// WEBPACK FOOTER //
// ./src/utility/api/holdreasonApi.js